<template>
  <UiKitFonts />
</template>

<script>
import UiKitFonts from '@/containers/ui-kit/UiKitFonts.vue'
export default {
  name: 'UiKit',
  components: {
    UiKitFonts,
  },
  data() {
    return {}
  },
}
</script>
